import { onBeforeUnmount, onMounted, ref } from 'vue';

/* Deslocamento a partir do qual o gesto conta como arrasto, e nao como clique. */
const LIMITE_DE_ARRASTO = 4;

/*
 * Arrasto horizontal por cima da rolagem nativa do elemento, mais as medidas de
 * progresso usadas para barra e mascara de continuidade.
 *
 * Toque e caneta ja rolam nativamente, entao o arrasto manual atende so o mouse.
 * Ligar `aoPressionar` ao pointerdown do elemento, `atualizarMedidas` ao evento
 * de rolagem, e `referencia` ao ref.
 */
export default function usarArrasteHorizontal() {
  const referencia = ref(null);
  const arrastando = ref(false);
  const progresso = ref(0);
  const podeAvancar = ref(false);

  let arrastou = false;
  let inicioDoPonteiro = 0;
  let inicioDaRolagem = 0;

  function atualizarMedidas() {
    const elemento = referencia.value;
    if (!elemento) return;

    const maximo = elemento.scrollWidth - elemento.clientWidth;

    progresso.value = maximo > 0 ? Math.min(Math.max(elemento.scrollLeft / maximo, 0), 1) : 0;
    podeAvancar.value = maximo - elemento.scrollLeft > 1;
  }

  function aoMover(evento) {
    if (!arrastando.value) return;

    const deslocamento = evento.clientX - inicioDoPonteiro;

    if (Math.abs(deslocamento) > LIMITE_DE_ARRASTO) arrastou = true;
    referencia.value.scrollLeft = inicioDaRolagem - deslocamento;
  }

  function encerrarArrasto() {
    arrastando.value = false;
    window.removeEventListener('pointermove', aoMover);
    window.removeEventListener('pointerup', encerrarArrasto);
    window.removeEventListener('pointercancel', encerrarArrasto);
  }

  /*
   * O arrasto acompanha o ponteiro por eventos na janela, e nao por
   * setPointerCapture: capturar o ponteiro no trilho faz o navegador entregar a
   * ele tambem o clique derivado, que entao nunca chega aos botoes de dentro.
   */
  function aoPressionar(evento) {
    arrastou = false;

    if (evento.pointerType !== 'mouse') return;

    arrastando.value = true;
    inicioDoPonteiro = evento.clientX;
    inicioDaRolagem = referencia.value.scrollLeft;

    window.addEventListener('pointermove', aoMover);
    window.addEventListener('pointerup', encerrarArrasto);
    window.addEventListener('pointercancel', encerrarArrasto);
  }

  function arrastouOConteudo() {
    return arrastou;
  }

  onMounted(() => {
    atualizarMedidas();
    window.addEventListener('resize', atualizarMedidas);
  });

  onBeforeUnmount(() => {
    encerrarArrasto();
    window.removeEventListener('resize', atualizarMedidas);
  });

  return {
    referencia,
    arrastando,
    progresso,
    podeAvancar,
    atualizarMedidas,
    aoPressionar,
    arrastouOConteudo
  };
}
